export default "__VITE_ASSET__Cju5wNNs__"